import { tabsApiConnector } from 'apiConnector/tabs/tabs';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, filter, map, mergeMap } from 'rxjs/operators';
import type { EpicWithThunk } from 'state/state.common';
import { workspaceTabsFetchFailed } from 'state/workspaces/workspace.actions';
import { workspaceTabsFetchedThunk } from 'state/workspaces/workspace.thunks';

export function fetchDynamicWorkspaceTabsEpic(): EpicWithThunk {
  return (action$, _state$, { httpClient }) =>
    action$.pipe(
      ofType('WORKSPACE_TABS_FETCH_REQUESTED'),
      filter(({ workspace }) => workspace === 'dynamic'),
      mergeMap(({ tabFetchRequestId }) =>
        tabsApiConnector(httpClient, 'dynamic')
          .getAllTabDescriptions()
          .pipe(
            map(({ tabs, activeTabId }) => {
              const actualActiveTabId: string | undefined = activeTabId ?? tabs[0]?.id ?? undefined;
              return workspaceTabsFetchedThunk(tabs, actualActiveTabId, 'dynamic', tabFetchRequestId);
            }),
            catchError((_: Error) => {
              return of(workspaceTabsFetchFailed('dynamic', tabFetchRequestId));
            }),
          ),
      ),
    );
}
